<script setup>
import { computed } from "vue";
import Login from "./views/Login.vue";
import { useAppStore } from "./services/Store";
import AppLoader from "@/components/AppLoader.vue";
import { useRoute } from "vue-router";

const app = useAppStore();
const route = useRoute();

// Forces a fresh remount of the top-level route component whenever the
// top-level route pattern or the :websiteId param changes — e.g. moving
// between different websites' workspaces, or from the website list into
// a workspace. Deliberately does NOT change between child tabs of the
// same workspace (overview -> articles -> schedule etc.), since those
// share the same top-level matched route and websiteId, so the sidebar
// and its state aren't needlessly remounted on every tab click.
const routeIdentityKey = computed(() => `${route.matched[0]?.path || route.path}::${route.params.websiteId || ""}`);
</script>

<template>
  <div class="font-poppins">
    <AppLoader v-if="app.loading" />
    <router-view :key="routeIdentityKey"> </router-view>
  </div>
</template>